import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';
import { BreadcrumbTrail } from '@/components/content/BreadcrumbTrail';

interface DpBreadcrumbTrailProps extends DpContainerProps {}

export const DpBreadcrumbTrail = (props: DpBreadcrumbTrailProps) => (
	<DpContainer withoutmargin isPLP {...props}>
		<BreadcrumbTrail id="breadcrumb-trail" />
	</DpContainer>
);
